import { RecipientSuggestion } from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function getRecipientSuggestions(query: string, limit?: number): Promise<RecipientSuggestion[]> {
  return httpClient.get<RecipientSuggestion[]>('/protected/messaging/recipient-suggestions', {
    params: { ...(query ? { query } : {}), ...(limit ? { limit } : {}) },
  });
}
